<nz-table
  class="revision-grid"
  #nzTable
  #expandTable
  [nzData]="listOfMapData"
  [nzPageSize]="listOfMapData.length"
  [nzShowPagination]="false"
  [nzScroll]="gridScrollValue"
  [nzLoading]="loading"
  *ngIf="showGrid"
>
  <thead>
    <tr>
      <th
        *ngFor="let data of gridHeader.level1; index as i"
        [attr.rowspan]="data.rowspan"
        [attr.colspan]="data.colspan"
        [nzWidth]="data.width"
        [ngClass]="{
          'border-right': data.borderRight,
          'border-right-dotted': data.borderRightDotted
        }"
        [nzLeft]="data.nzLeft"
        [class.lineitem-column-collapsed]="i === 0 && !lineItemHeadersExpanded"
        [nzAlign]="data.align"
      >
        <span
          *ngIf="i == 0"
          class="line-item-header-expansion"
          (click)="onLineItemColumnCollapse()"
        >
          <img
            *ngIf="lineItemHeadersExpanded"
            [src]="assets + '/collapse.png'"
            alt=""
          />
          <img
            *ngIf="!lineItemHeadersExpanded"
            [src]="assets + '/expand.png'"
            alt=""
          />
        </span>
        {{ data.label }}<span *ngIf="data.label && i != 0" class="tag">E</span>
      </th>
    </tr>
    <tr>
      <th
        *ngFor="let data of gridHeader.level2; index as i"
        [nzWidth]="data.width"
        [ngClass]="{
          'border-right': data.borderRight,
          'border-right-dotted': data.borderRightDotted,
          'value-header': data.valueHeader,
          'hide-cell': data.width === '0px'
        }"
        [nzAlign]="data.align"
      >
        <span
          *ngIf="data.label !== '%Change'"
          nz-popover
          nzPopoverContent="Updated: {{ popOverMapping[data.popoverKey] }}"
          nzPopoverPlacement="bottom"
          >{{ data.label }}</span
        >
        <span *ngIf="data.label === '%Change'">{{ data.label }}</span>
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let data of expandTable.data">
      <ng-container *ngFor="let item of mapOfExpandedData[data.key]">
        <tr
          *ngIf="(item.parent && item.parent.expand) || !item.parent"
          [hidden]="item.hidden"
          [ngClass]="{ 'blank-row': item.header === true && item.name === ' ' }"
        >
          <!-- lineitem name / tab name column -->
          <td
            [nzIndentSize]="item.level * 1"
            [nzShowExpand]="!!item.children && !item.isExpandableRow"
            [(nzExpand)]="item.expand"
            (nzExpandChange)="
              collapse(mapOfExpandedData[data.key], item, $event)
            "
            [nzLeft]="'0px'"
            [ngClass]="{
              'expanded-name': item.isExpandableRow && item.expand,
              'border-right-dotted': !item.isTabRow && !item.header,
              'tab-cell': item.isTabRow || item.header
            }"
            [class.hide-cell]="!item.name"
            [attr.rowspan]="
              !item.isTabRow && item.expand ? selectedSourceList.length + 1 : 1
            "
            [class.lineitem-column-collapsed]="!lineItemHeadersExpanded"
          >
          <div class="lineitem-td-container">
            <span class="lineitem-name" *ngIf="item.header">{{
              item.name
            }}</span>
            <span class="lineitem-name" *ngIf="item.isTabRow"
              >{{ item.name
              }}<span *ngIf="tabLineCountMapping[item.name] !== ''"
                >({{ tabLineCountMapping[item.name] }})</span
              ></span
            >
            <span class="lineitem-name" *ngIf="!item.isTabRow && !item.header"
              >{{ item.name
              }}<span *ngIf="item.parameter_unit !== ''">{{
                item.parameter_unit
              }}</span></span
            >
          </div>
          </td>
          <!-- bar chart column -->
          <td
            [nzLeft]="lineItemHeadersExpanded ? '300px' : '190px'"
            [ngClass]="{
              'border-right-dotted': !item.isTabRow && !item.header
            }"
            (click)="showChartPopup(item, 'revision-analysis')"
          >
            <va-icon
              size="small"
              name="chart-bar"
              *ngIf="!item.isTabRow && !item.header"
              class="chart-icon"
            ></va-icon>
          </td>
          <!-- source column -->
          <td
            [nzLeft]="lineItemHeadersExpanded ? '330px' : '220px'"
            [nzShowExpand]="!!item.children && item.isExpandableRow"
            [(nzExpand)]="item.expand"
            (nzExpandChange)="
              collapse(mapOfExpandedData[data.key], item, $event)
            "
            [ngClass]="{ 'border-right': !item.isTabRow && !item.header }"
            class="left-align"
          >
            <span
              [ngClass]="{
                'broker-value':
                  !item.isExpandableRow && !item.header && !item.isTabRow
              }"
              class="source-value"
            >
              <span class="excluded-icon-container">
                <img
                  *ngIf="item.level > 1 && isSourceExcluded[item.source]"
                  [src]="assets + '/icon-excluded.png'"
                  alt=""
                />
              </span>
              {{ item.source }}
            </span>
          </td>

          <!-- values columns -->
          <ng-container *ngIf="!item.isTabRow && !item.header === true">
            <ng-container *ngFor="let period of revisionMeta.periods">
              <td
                *ngFor="
                  let column of gridFilters.onlyPercentChange
                    ? ['percent-change']
                    : gridFilters.showYoyPercent
                    ? ['revision-yoy', 'current-yoy']
                    : ['revision', 'current', 'percent-change']
                "
                [ngClass]="{
                  'border-right-dotted': !item.isTabRow,
                  'highlight-green':
                    column === 'percent-change' &&
                    item['highlight-green-' + period],
                  'highlight-red':
                    column === 'percent-change' &&
                    item['highlight-red-' + period],
                  'highlight-background':
                    highlightBackground !== '' &&
                    highlightBackground ===
                      item[column + '-dpid-' + period] + column
                }"
                class="right-align value-cell"
                (click)="setDPParams(item, period, column)"
              >
                <!-- {{ item[column + "-" + period] }} -->
                <app-value-renderer
                  [value]="item[column + '-' + period]"
                  [precision]="item.precision ? item.precision : 2"
                  [cut]="''"
                  [unit]="
                    column === 'percent-change' ||
                    gridFilters.showYoyPercent === true
                      ? item['unit-' + period]
                        ? item['unit-' + period] === '%'
                          ? 'bps'
                          : '%'
                        : ''
                      : ''
                  "
                  [isPercentChange]="column === 'percent-change'"
                >
                </app-value-renderer>
              </td>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="item.isTabRow || item.header === true">
            <!-- handling for tab rows -->
            <ng-container
              *ngFor="
                let col of gridFilters.onlyPercentChange
                  ? [1]
                  : gridFilters.showYoyPercent
                  ? [1, 2]
                  : [1, 2, 3]
              "
            >
              <td *ngFor="let period of revisionMeta.periods"></td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
</nz-table>
<app-chart-popup
  [chartType]="chartPopupType"
  [dataToUse]="chartPopupDataToUse"
  [(showPopup)]="chartPopupVisible"
  (closePopup)="hideChartPopup()"
  [beginningStateReferrer]="beginningStateReferrer"
  [closeFeature]="feature"
></app-chart-popup>
